import { render, staticRenderFns } from "./CrudShipments.vue?vue&type=template&id=3f3081b3&scoped=true"
import script from "./CrudShipments.vue?vue&type=script&lang=js"
export * from "./CrudShipments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3081b3",
  null
  
)

export default component.exports